import {
  CLEAR_DISCIPLINARY_MESSAGE,
  DELETE_DISCIPLINARY,
  DELETE_DISCIPLINARY_FAILURE,
  DELETE_DISCIPLINARY_SUCCESS,
  FETCH_DISCIPLINARY,
  FETCH_DISCIPLINARY_FAILURE,
  FETCH_LOCATION_DISCIPLINARY,
  FETCH_LOCATION_DISCIPLINARY_FAILURE,
  FETCH_LOCATION_DISCIPLINARY_SUCCESS,
  FETCH_DISCIPLINARY_RECORD,
  FETCH_DISCIPLINARY_RECORD_FAILURE,
  FETCH_DISCIPLINARY_RECORD_SUCCESS,
  FETCH_DISCIPLINARY_SUCCESS,
  POST_DISCIPLINARY_ACTION,
  POST_DISCIPLINARY_ACTION_FAILURE,
  POST_DISCIPLINARY_ACTION_SUCCESS,
  SAVE_DISCIPLINARY,
  SAVE_DISCIPLINARY_FAILURE,
  SAVE_DISCIPLINARY_SUCCESS,
  UPLOAD_DISCIPLINARY_ATTACHMENT,
  UPLOAD_DISCIPLINARY_ATTACHMENT_FAILURE,
  UPLOAD_DISCIPLINARY_ATTACHMENT_SUCCESS,
} from "./constants";

export const fetchDisciplinary = (employeeUuid) => ({
  type: FETCH_DISCIPLINARY,
  payload: { employeeUuid },
});

export const fetchDisciplinarySuccess = (payload) => ({
  type: FETCH_DISCIPLINARY_SUCCESS,
  payload,
});

export const fetchDisciplinaryFailure = (payload) => ({
  type: FETCH_DISCIPLINARY_FAILURE,
  payload,
});

export const fetchLocationDisciplinary = (payload) => ({
  type: FETCH_LOCATION_DISCIPLINARY,
  payload,
});

export const fetchLocationDisciplinarySuccess = (payload) => ({
  type: FETCH_LOCATION_DISCIPLINARY_SUCCESS,
  payload,
});

export const fetchLocationDisciplinaryFailure = (payload) => ({
  type: FETCH_LOCATION_DISCIPLINARY_FAILURE,
  payload,
});

export const fetchDisciplinaryRecord = (uuid) => ({
  type: FETCH_DISCIPLINARY_RECORD,
  payload: { uuid },
});

export const fetchDisciplinaryRecordSuccess = (payload) => ({
  type: FETCH_DISCIPLINARY_RECORD_SUCCESS,
  payload,
});

export const fetchDisciplinaryRecordFailure = (payload) => ({
  type: FETCH_DISCIPLINARY_RECORD_FAILURE,
  payload,
});

export const saveDisciplinary = (payload, onSuccess) => ({
  type: SAVE_DISCIPLINARY,
  payload,
  onSuccess,
});

export const saveDisciplinarySuccess = (payload) => ({
  type: SAVE_DISCIPLINARY_SUCCESS,
  payload,
});

export const saveDisciplinaryFailure = (payload) => ({
  type: SAVE_DISCIPLINARY_FAILURE,
  payload,
});

export const postDisciplinaryAction = (payload, onSuccess) => ({
  type: POST_DISCIPLINARY_ACTION,
  payload,
  onSuccess,
});

export const postDisciplinaryActionSuccess = (payload) => ({
  type: POST_DISCIPLINARY_ACTION_SUCCESS,
  payload,
});

export const postDisciplinaryActionFailure = (payload) => ({
  type: POST_DISCIPLINARY_ACTION_FAILURE,
  payload,
});

export const clearDisciplinaryMessage = () => ({
  type: CLEAR_DISCIPLINARY_MESSAGE,
});

export const deleteDisciplinary = (payload, onSuccess) => ({
  type: DELETE_DISCIPLINARY,
  payload,
  onSuccess,
});

export const deleteDisciplinarySuccess = () => ({
  type: DELETE_DISCIPLINARY_SUCCESS,
});

export const deleteDisciplinaryFailure = () => ({
  type: DELETE_DISCIPLINARY_FAILURE,
});

export const uploadDisciplinaryAttachment = (payload, onSuccess) => ({
  type: UPLOAD_DISCIPLINARY_ATTACHMENT,
  payload,
  onSuccess,
});

export const uploadDisciplinaryAttachmentSuccess = (payload) => ({
  type: UPLOAD_DISCIPLINARY_ATTACHMENT_SUCCESS,
  payload,
});

export const uploadDisciplinaryAttachmentFailure = (payload) => ({
  type: UPLOAD_DISCIPLINARY_ATTACHMENT_FAILURE,
  payload,
});
